<!-- <div class="pos-summary-reports-container col-md-12 no-padding">
    <div id="posreportsummary">
        <div class="row no-margin">
            <div class="col-md-9 no-padding">
                <div class="row paddingtop-20">
                    <div class="col-md-5 reports-label text-underline">
                        {{'reports.POS Order Summary Report' |translate |translateKey}}
                    </div>
                </div>
                <div class="row pt-5">
                    <div class="col-md-3 reports-label">
                        {{'reports.Area' |translate |translateKey}}<span class="float-right">:</span>
                    </div>
                    <div class="col-md-8">
                        <label>{{areaCode}}</label>
                    </div>
                </div>
                <div class="row pt-5">
                    <div class="col-md-3 reports-label">
                        {{"reports.Today's Date / Time" |translate |translateKey}} <span class="float-right">:</span>
                       
                    </div>
                    <div class="col-md-8">
                        <label> {{currentDate | date: 'dd-MMM-yyyy HH:mm:ss'}}</label>
                    </div>
                </div>
                <div class="row pt-5">
                    <div class="col-md-3 reports-label">
                        {{'reports.Number of Orders' |translate |translateKey}} <span class="float-right">:</span>
                        
                    </div>
                    <div class="col-md-8">
                        <label *ngIf="reportsSummary && reportsSummary.posOrderCount;else empty_content_count">
                            {{ reportsSummary.posOrderCount }}
                        </label>
                        <ng-template #empty_content_count>0</ng-template>
                    </div>
                </div>
            </div>
            <div class="col-md-3 no-padding">
                <div id="icons-container" class="row float-right paddingtop-90">
                    <div class="col-md-12 no-padding">
                        <div class="col-md-3 right-padding-0">
                            <span (click)="addToFavorite()">
                                <i class="fa-heart-o fa pointer icon-heart"
                                    title="{{'reports.Add to Favorite' |translate |translateKey }}"></i>
                            </span>
                        </div>
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('print')" (click)="exportFile('print')"
                                class="iconButtons" [disabled]="isAllReportsSummaryLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="printIconUrl" alt="{{'customer-service.Print' |translate |translateKey }}"
                                        title="{{'customer-service.Print' |translate |translateKey }}" />
                                </span>
                            </button>
                        </div>        
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('csv')" (click)="exportFile('csv')"
                                class="iconButtons" [disabled]="isAllReportsSummaryLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="excelIconUrl"
                                        alt="{{'reports.Export CSV' |translate |translateKey}}"
                                        title="{{'reports.Export CSV' |translate |translateKey}}"/>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 no-padding mt-10 mb-10">
            <div class="table-responsive">
                <table class="table-sm table-hover table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th class="cursor-pointer">{{'reports.Date/Time' |translate |translateKey }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Processing Period' |translate |translateKey }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Web Order #' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Order' |translate |translateKey  }} #&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Status' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Member' |translate |translateKey  }} #&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Member Name' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.User Name' |translate |translateKey  }} &nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Discount' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Vat' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Handling Charge' |translate |translateKey  }}&nbsp;</th>
                            <th class="cursor-pointer">{{'reports.Total Rcvd' |translate |translateKey  }}&nbsp;</th>
                            <ng-container *ngFor="let methods of paymentMethods">
                                <th class="cursor-pointer">{{'reports.'+ methods.paymentMethodName |translate |translateKey  }}</th>
                            </ng-container>
                            <th class="cursor-pointer">{{'reports.Total' |translate |translateKey  }}&nbsp;</th> 
                            <th class="cursor-pointer">{{'reports.Notes' |translate |translateKey  }}&nbsp;</th> 
                        </tr>
                    </thead>
                    <colgroup>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        <ng-container *ngFor="let methods of paymentMethods">
                            <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        </ng-container>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                        <col [ngStyle]= "{ 'width':colGroupWidth }"/>
                    </colgroup>
                    <tbody
                        *ngIf="!isLoading && reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length > 0">
                        <tr
                            *ngFor="let report of reportsSummary.posOrderModel | paginate: {  id: 'pos-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                            <td>{{report.orderPostedDate | date: 'dd-MMM-yyyy HH:mm:ss'}}</td>
                            <td>{{report.processingPeriod}}</td>
                            <td>{{report.webOrderID}}</td>
                            <td>{{report.orderNumber}}</td>
                            <td>{{report.orderStatus}}</td>
                            <td>{{report.distributorId}}</td>
                            <td>{{report.memberName}}</td>
                            <td>{{report.userName}}</td>
                            <td>{{report.discountAmount}}</td>
                            <td>{{report.vatAmount}}</td>
                            <td>{{report.handlingCharge}}</td>
                            <td>{{report.totalAmountRcvd}}</td>
                            <ng-container *ngFor="let methods of paymentMethods">
                                <td>{{report.paymentList && report.paymentList[methods.paymentMethodKey] ? currenyFormatValue(report.paymentList[methods.paymentMethodKey]) : ''}}</td>
                            </ng-container>
                            <td>{{report.orderTotal ? currenyFormatValue(report.orderTotal) : ''}}</td>
                            <td>{{report.paymentNote}}</td>
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="!isLoading && reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length > 0">
                        <tr>
                            <td colspan="10"></td>
                            <td class="bold">{{'reports.Total' |translate |translateKey }}</td>
                            <ng-container *ngFor="let methods of paymentMethods">
                                <td>{{reportsSummary.paymentTotal && reportsSummary.paymentTotal[methods.paymentMethodKey] ? currenyFormatValue(reportsSummary.paymentTotal[methods.paymentMethodKey]) : ''}}</td>
                            </ng-container>
                            <td>{{reportsSummary.orderTotalSum ? currenyFormatValue(reportsSummary.orderTotalSum) : ''}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="(!isLoading && (reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length === 0)) || (isResponseError && !isLoading)">
                        <tr>
                            <td [attr.colspan]="headerLength" class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td [attr.colspan]="headerLength" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 paddingbot-20"
                *ngIf="reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length > 0">
                <span>{{reportsSummary.posOrderModel.length}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls id="pos-reports-pagination" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </div>
        <div class="col-md-12 padding-lr-0 paddingbot-20">
            <div class="col-md-4 padding-lr-0">
                <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
                    [disabled]="!(reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length > 0)"
                    (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
                    <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
                </select>
            </div>
        </div>
    </div>
</div> -->
<div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(!isLoading && (reportsSummary && reportsSummary.posOrderModel && reportsSummary.posOrderModel.length === 0)) || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/pos-summary-reports.component.html